import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { logger } from '@zep/core-logger';

import { type QuizSetDetailsRes } from '@/api';
interface UseEditHandlerParams {
  quizId: string;
  quizData: QuizSetDetailsRes;
}

/**
 * useEditHandler - 수정하기 핸들러
 *
 * @description
 * 퀴즈 수정 페이지로 이동합니다.
 */
export const useEditHandler = ({ quizId, quizData }: UseEditHandlerParams) => {
  const router = useRouter();

  return useCallback(() => {
    void router.push({
      pathname: `/update/${quizId}`,
    });
    logger.track('enter_update', {
      location: 'detail',
      spaceId: quizData.id,
    });
  }, [router, quizId, quizData]);
};
